export const chooseVeeamReasonsList = [
  {
    title: "chooseVeeam.flexibleBackups.title",
    description: "chooseVeeam.flexibleBackups.description",
    iconUrl: "flexibleBackups",
  },
  {
    title: "chooseVeeam.secureCloudStorage.title",
    description: "chooseVeeam.secureCloudStorage.description",
    iconUrl: "secureCloudStorage",
  },
  {
    title: "chooseVeeam.kvmCompatible.title",
    description: "chooseVeeam.kvmCompatible.description",
    iconUrl: "kvmCompatible",
  },
  {
    title: "chooseVeeam.comprehensiveDataProtection.title",
    description: "chooseVeeam.comprehensiveDataProtection.description",
    iconUrl: "comprehensiveDataProtection",
  },
  {
    title: "chooseVeeam.crossLocationRecovery.title",
    description: "chooseVeeam.crossLocationRecovery.description",
    iconUrl: "crossLocationRecovery",
  },
  {
    title: "chooseVeeam.enterpriseGradeReliability.title",
    description: "chooseVeeam.enterpriseGradeReliability.description",
    iconUrl: "enterpriseGradeReliability",
  }
];

export const exploreOptionsList = [
  {
    title: "exploreOptions.privateDataCenter.title",
    description: "exploreOptions.privateDataCenter.description",
    imageUrl: '/services/veeam/privateDataCenter.webp',
  },
  {
    title: "exploreOptions.publicDataCenter.title",
    description: "exploreOptions.publicDataCenter.description",
    imageUrl: '/services/veeam/publicDataCenter.webp',
  }
];

export const continuousInnovationList = [
  {
    title: "continuousInnovation.regularUpdates.title",
    description: "continuousInnovation.regularUpdates.description",
    iconUrl: "regularUpdates",
  },
  {
    title: "continuousInnovation.expertSupport.title",
    description: "continuousInnovation.expertSupport.description",
    iconUrl: "expertSupport",
  }
]
